module.exports = __webpack_public_path__ + "static/media/tokenization.c4f221de.png";